require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-grossmuerbisch.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-grossmuerbisch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-grossmuerbisch!./.cache/json/betreuungseinrichtungen-guessing-grossmuerbisch.json
// module id = 886
// module chunks = 231608221292675